import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth'
import { AngularFirestore } from '@angular/fire/firestore'
import  auth  from 'firebase/app';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Capacitor } from '@capacitor/core';
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook/ngx';
import * as firebase from 'firebase';
import { AngularFireAnalytics } from '@angular/fire/analytics';

import { Plugins } from '@capacitor/core';
 
const { Device, SignInWithApple } = Plugins;
 
declare var webengage
@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  showAppleSignIn = false;
  country_id = 0 
  constructor(
    private googlePlus: GooglePlus,
    private fb: Facebook,
    public angularFireAuth : AngularFireAuth, public firestore : AngularFirestore, public http:HttpClient, public common : CommonService, public messageService : MessageService, public router:Router, public auth:AuthService, public analytics: AngularFireAnalytics) {
      //const device = await Device.getInfo();
      this.showAppleSignIn = Capacitor.getPlatform()=="ios";
     }
  get_country_id : boolean = false
  // signIn(email, password){
  //   this.angularFireAuth.signInWithEmailAndPassword(email, password)
  //   .then(res => {
  //     //console.log(res)
  //   })
  //   .catch(err => {
  //     //console.log(err)
  //   })
  // }

  // signUp(form : NgForm){
  //   //console.log(form.value)
  //   this.angularFireAuth.createUserWithEmailAndPassword(form.value.email, form.value.password)
  //   .then((res:any) => { 
  //     //console.log(res)
  //     localStorage.setItem('user', res.user)
  //     // this.firestore.
  //   })
  //   .catch(err => {
  //     //console.log(err)
  //   })
  // }

  signOut(){
    this.angularFireAuth.signOut()
    .then(res => {
      //console.log(res)
    })
    .catch(err => {
      //console.log(err)
    })
  }

  async signInWithGoogle(){
    this.common.showLoader()
    var provider = new auth.auth.GoogleAuthProvider();
    var country_id = 0
    var credential
    if(Capacitor.getPlatform()=="android" || Capacitor.getPlatform()=="ios"){
      try {
        const res = await this.googlePlus.login({
          webClientId: environment.googleClientId
        });
        this.common.stopLoader()
        this.onGoogleLoginSuccess(res.accessToken,res.idToken)
      } catch (err) {
        console.error(err);
        this.common.stopLoader()
      }
    }else{
      await this.angularFireAuth.signInWithPopup(provider).then(res => {
        credential = res
        if(credential.additionalUserInfo.isNewUser){
          this.analytics.logEvent('sign_up_with_google', {});
          // webengage.track("Sign_up ", {
          //   "Email" : "AXK1337",
          //   "User id" : 39.80,
          //   });
        }
        this.proceedWithFirebaseLogin('', 'google')

      }).catch(err => {
        this.common.stopLoader()
  
      })
    }
    

  }

  async signInWithApple(){
    this.common.showLoader()
    
    

    //var credential
    if(Capacitor.getPlatform()=="android" || Capacitor.getPlatform()=="ios"){
      try {
        const res = await this.googlePlus.login({
          webClientId: environment.googleClientId
        });
        
       
        this.common.stopLoader()
        this.onGoogleLoginSuccess(res.accessToken,res.idToken)
       
      } catch (err) {
        console.error(err);
        //alert("error")
        this.common.stopLoader()
      }
    }else{
      const provider = new firebase.default.auth.OAuthProvider('apple.com');
      await this.angularFireAuth.signInWithPopup(provider).then(res => {
        //console.log(res)
        let credential = res
        if(credential.additionalUserInfo.isNewUser){
          this.get_country_id = true
          this.common.stopLoader()
        }
        else{
          this.proceedWithFirebaseLogin()
        }
      }).catch(err => {
        //console.log(err)
        this.common.stopLoader()
  
      })
    }
    

  }

  async signInWithFacebook(){

    // https://n2xpress.firebaseapp.com/__/auth/handler
    this.common.showLoader()
    if(Capacitor.getPlatform()=="android" || Capacitor.getPlatform()=="ios"){
      //this.fb.logout()
      this.fb.login(['public_profile'])
      .then((res: FacebookLoginResponse) => {
        this.common.stopLoader()
        this.onFacebookLoginSuccess(res)
        //alert(res)
        //console.log(res)
      })
      .catch(e => {
        this.common.stopLoader()
      });
    }else{
      var provider = new auth.auth.FacebookAuthProvider();
      var country_id = 0
      var credential 
      await this.angularFireAuth.signInWithPopup(provider).then(res => {
        credential = res
        if(credential.additionalUserInfo.isNewUser){
          this.analytics.logEvent('sign_up_with_facebook', {});
        }
        this.proceedWithFirebaseLogin('', 'facebook')

      }).catch(err => {
        //console.log(err)
        this.common.stopLoader()
      })
      
    }
    
  }

  async proceedWithFirebaseLogin(displayName?, type?){
    (await this.angularFireAuth.currentUser).getIdToken().then(res => {
      this.common.showLoader()
      let postData={}
      if(displayName){
        postData = {name:displayName, type:type}
      }
      else 
        postData = {type: type}
      this.http.post(`${environment.api_link}/api/auth/firebase_login?token_string=${res}&country_id=${this.country_id}`,postData).subscribe((res:any) => {
        if(res.data?.access_token){
          localStorage.setItem("access_token",res.data.access_token)
          this.http.post(environment.api_link+'/api/auth/me',{}).subscribe((res:any)=>{
            localStorage.setItem("user",JSON.stringify(res.data))
            webengage.user.login(res.data.id)
            webengage.user.setAttribute('we_email', res.data.email)
            webengage.track("user_logged", {
              "user id" : res.data.id,
              "user country" : res.data.country_id || 0,
            });
            webengage.track("Login", {
              "Email" : res.data.email,
              "User id" : res.data.id,
            });
            webengage.track("login_existing_user", {
              "Name" : `${res.data.name?res.data.name:''} ${res.data.lastname?res.data.lastname:''}`,
              "Country" : res.data.country_id || 0,
              "State" : res.data.state_id || 0,
              "Phone" : res.data.mob_num || 0,
              "Is_verified" : res.data.verified 
            });
            this.auth.user = res.data
            this.common.stopLoader()
            if(!res.data.verified){
            this.router.navigateByUrl("/account")
            }
            else
              this.router.navigateByUrl('/dashboard')
          },err=>{
            localStorage.removeItem("access_token")
            this.common.stopLoader()
            //alert(JSON.stringify(err))
            this.messageService.add({severity:'error',summary:'Something went wrong'})
          })
        }
        else if(!res.return){
          this.common.stopLoader()
          this.messageService.add({severity:'error',summary:res.message})
        }
        else{
          this.common.stopLoader()
          this.messageService.add({severity:'error',summary:'Something went wrong'})
        }
      }, err => {
        this.common.stopLoader()
        //alert(JSON.stringify(err))
        this.messageService.add({severity:'error',summary:'Something went wrong'})
      })
    }, err =>{
      this.common.stopLoader()
      //alert(JSON.stringify(err))
      this.messageService.add({severity:'error',summary:'Something went wrong 3'})
    })
  }
  //FOR FUTURE USE
  // signInWithTwitter(){

  // }

  // signInWithMicrosoft(){

  // }

  onGoogleLoginSuccess(accessToken, idToken) {
    //alert("on logged in")
    //alert(idToken)
    //alert(accessToken)
    this.common.showLoader()
    const credential =  firebase.default.auth.GoogleAuthProvider
            .credential(idToken);
    this.angularFireAuth.signInWithCredential(credential)
      .then(res => {
        //console.log(res)
        //alert("final then")
        if(res.additionalUserInfo.isNewUser){
          this.get_country_id = true
          this.common.stopLoader()
        }
        else{
          this.proceedWithFirebaseLogin()
        }
      }).catch(err => {
        //alert(err)
        //alert("eror then")
        this.common.stopLoader()
  
      }).finally(()=>{
        this.common.stopLoader()
      })

  }

  onFacebookLoginSuccess(res: FacebookLoginResponse){
    this.common.showLoader()
    const credential = firebase.default.auth.FacebookAuthProvider.credential(res.authResponse.accessToken);
    this.angularFireAuth.signInWithCredential(credential)
    .then(res => {
      //console.log(res)
      //alert("final then")
      if(res.additionalUserInfo.isNewUser){
        this.get_country_id = true
        this.common.stopLoader()
      }
      else{
        this.proceedWithFirebaseLogin()
      }
    }).catch(err => {
      //alert(err)
      //alert("eror then")
      this.common.stopLoader()

    }).finally(()=>{
      this.common.stopLoader()
    })
  }

  openAppleSignIn() {
    SignInWithApple.Authorize().then(async res => {
      if (res.response && res.response.identityToken) {
        //alert("token generated")
        //alert(JSON.stringify(res.response))
        this.createFirebaseuserFromApple(res.response);
        
        
      } else {
        //alert("Please try again")
      }
    }).catch(response => {
      //alert("please try again")
    });
  }

  async createFirebaseuserFromApple(appleResponse) {
    this.common.showLoader()
    // Create a custom OAuth provider    
    const provider = new firebase.default.auth.OAuthProvider('apple.com');
 
    // Create sign in credentials with our token
    const credential = provider.credential({
      idToken: appleResponse.identityToken
    });
    
    // Call the sign in with our created credentials
    this.angularFireAuth.signInWithCredential(credential).then(res => {
      //alert("account created successfully")
      this.common.showLoader()
      //console.log(res)
      //alert("final then")
      if(res.additionalUserInfo.isNewUser){
        this.get_country_id = true
        this.common.stopLoader()
      }
      else{
        this.proceedWithFirebaseLogin(appleResponse.givenName)
      }
    }).catch(err => {
      //alert(err)
      //alert("eror then")
      this.common.stopLoader()

    }).finally(()=>{
      this.common.stopLoader()
    })
  }
}
